<template lang="pug">
v-card(:to="to", width="300px", :max-width="maxWidth")
  //- v-card-subtitle.pb-0.black--text(:datetime="date") {{ time }}:
  v-card-title.black--text.text-uppercase.font-weight-bold.communication-card-title.pt-0.break-word.text-body-1 {{ title }}
  .px-4.pb-4
    .communication-card-decoration.rounded-pill.primary.py-1
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    date: {
      type: String,
      required: true,
    },
    to: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: [String, Number],
      default: "300px",
    },
  },
  computed: {
    time() {
      return new Intl.DateTimeFormat("pt-BR", { dateStyle: "long" }).format(
        new Date(this.date)
      );
    },
  },
};
</script>

<style>
.communication-card-title {
  line-height: 20px !important;
}
.communication-card-decoration {
  width: 50%;
}
</style>
